define(["dojo/i18n", "/home/semaphore/scramble4/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js"
,"scramble/models/nls/zh-tw/document"
,"scramble/models/nls/zh/document"
,"scramble/models/nls/ja/document"
,"scramble/models/nls/fr/document"
,"scramble/models/nls/de/document"
,"scramble/models/nls/ko/document"
,"scramble/models/nls/it/document"
,"scramble/models/nls/cs/document"
,"scramble/models/nls/tr/document"
,"scramble/models/nls/pl/document"
,"scramble/models/nls/fi/document"
,"scramble/models/nls/hu/document"
,"scramble/models/nls/sk/document"
,"scramble/models/nls/en-gb/document"
,"scramble/models/nls/nb/document"
,"scramble/models/nls/es/document"
,"scramble/models/nls/nl/document"
,"scramble/models/nls/pt/document"
,"scramble/models/nls/ru/document"
,"scramble/models/nls/sv/document"
,"/home/semaphore/scramble4/src/scramble/models/nls/document.js?absMid=scramble/models/nls/document"
], function(loader, runner) {
   return runner(loader, "scramble/models/nls/document", __webpack_require__.dj.c(), false);
});